import styled from "styled-components";

export const OfferedByContainer = styled.div`
  padding: 16px;
  width: fit-content;
  display: flex;
  align-items: center;
  background: #00000066;
  border-radius: 8px;
  gap: 8px;
`;

export const OfferedByTitle = styled.div`
  font-size: 14px;
  color: #ffffff;
`;

export const OfferedByValue = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 12px;
  text-align: right;
  width: 100%;
`;

export const OfferedByIconContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;

  > * + * {
    border-left: 1px solid #979797;
    padding-left: 12px;
  }
`;

export const OfferedByIcon = styled.img`
  height: 32px;
  width: auto;
  max-width: 60px;
  object-fit: contain;
`;
